<template>
  <div v-if="project">
    <div class="row text-center justify-content-center" id="HeadlineDescription">
      <div class="col-md-8">
        <h3>{{ project.title }}</h3>
        <router-link :to="basePath" class="back-link">Back to list</router-link>
      </div>
    </div>
    <div v-if="project.description" class="mt-4 row text-center justify-content-center">
      <div class="col-md-8">
        <ScrambleText ref="childRef" v-bind:text=project.description :playAudio="false"/>
      </div>
    </div>
    <!-- Changed from single media to support multiple media items -->
    <div v-if="project.media && project.media.length" class="row mt-3 justify-content-center">
      <div v-for="(mediaItem, mediaIdx) in project.media" :key="mediaIdx" class="col-md-12 mb-4 d-flex justify-content-center">
        <div v-html="mediaItem"></div>
      </div>
    </div>
    <div v-if="project.images && project.images.length" class="row mt-5 justify-content-center">
      <div v-for="(img, idx) in project.images" :key="idx" class="col-md-12 mb-4 d-flex justify-content-center">
        <div class="card h-100">
          <img :src="getImgUrl(img)" class="card-img-top" :alt="project.title">
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <p>Project not found.</p>
    <router-link :to="basePath" class="back-link">Back to list</router-link>
  </div>
</template>

<script>
import ScrambleText from './ScrambleText.vue';
const images = require.context('@/assets/img', true, /\.(png|jpe?g|svg|webp)$/);

export default {
  name: 'ProjectDetail',
  props: {
    slug: {
      type: String,
      required: true,
    },
    basePath: {
      type: String,
      required: true
    },
    jsonData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      project: null
    };
  },
  components: {
    ScrambleText
  },
  methods: {
    getImgUrl(path) {
      if (!path) return '';
      const cleanPath = path.replace(/^\//, '');
      try {
        return images('./' + cleanPath);
      } catch (e) {
        return '';
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.jsonData && this.jsonData.Projects) {
      this.project = this.jsonData.Projects.find(p => p.slug === this.slug);
      this.$nextTick(() => {
        if (this.$refs.childRef) {
          this.$refs.childRef.initScrambleWithText(this.project.description, 0.3, 0.5);
        }
      });
    }
  }
};
</script>

<style scoped>
#HeadlineDescription {
  margin-top: 5rem;
}
.card-img-top {
  max-height: 20rem;
  width: 100%;
  height: 25rem;
  max-width: 800px;
  object-fit: cover;
  margin: 0 auto;
  display: block;
}
:deep(iframe) {
  border: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}
.card {
  border: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}
.row.mt-5.justify-content-center {
  margin-top: 2rem !important;
  /* Remove row-gap to avoid extra space between columns */
}
.back-link {
  display: inline-block;
  margin-top: 1rem;
  text-decoration: none;
  color: inherit;
  font-weight: 500;
}
.back-link:hover {
  text-decoration: underline;
}
</style>
